import { useState } from 'react'
import { Smartphone, Plus, QrCode } from 'lucide-react'
import { WhatsAppMailboxList } from '@components/whatsapp/WhatsAppMailboxList'
import { WhatsAppMailboxForm } from '@components/whatsapp/WhatsAppMailboxForm'
import { WhatsAppMailbox } from '@/types'

export function WaMailboxesPage() {
  const [showForm, setShowForm] = useState(false)
  const [editingMailbox, setEditingMailbox] = useState<WhatsAppMailbox | null>(null)

  const handleEdit = (mailbox: WhatsAppMailbox) => {
    setEditingMailbox(mailbox)
    setShowForm(true)
  }

  const handleCloseForm = () => {
    setShowForm(false)
    setEditingMailbox(null)
  }

  const handleFormSuccess = () => {
    // Form will handle closing itself after success
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="icon-container icon-container-lg">
            <Smartphone size={28} className="text-emerald-500" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-slate-100">WhatsApp Connections</h1>
            <p className="text-sm text-slate-400 mt-1">
              Manage your WhatsApp phone connections and QR code authentication
            </p>
          </div>
        </div>
        <button
          onClick={() => {
            setEditingMailbox(null)
            setShowForm(true)
          }}
          className="btn-primary whatsapp-gradient whatsapp-glow"
        >
          <Plus size={20} />
          Add Connection
        </button>
      </div>

      {/* Info Banner */}
      <div className="glass-card rounded-xl p-4 border-emerald-500/20">
        <div className="flex items-start gap-3">
          <QrCode className="text-emerald-400 mt-0.5" size={20} />
          <div>
            <h3 className="font-medium text-emerald-300">Connect WhatsApp via QR Code</h3>
            <p className="text-sm text-slate-400 mt-1">
              Create a new connection, then click the menu (⋮) and select "Connect WhatsApp"
              to scan the QR code with your phone. Your WhatsApp will be linked to this system.
            </p>
          </div>
        </div>
      </div>

      {/* Mailbox List */}
      <WhatsAppMailboxList onEdit={handleEdit} />

      {/* Form Modal */}
      {showForm && (
        <WhatsAppMailboxForm
          mailbox={editingMailbox}
          onClose={handleCloseForm}
          onSuccess={handleFormSuccess}
        />
      )}
    </div>
  )
}
